"use client";

import ReactDOM from "react-dom";

const CDN_URL = process.env.NEXT_PUBLIC_CUSTOM_CDN_URL || "https://fecdn.bystadium.com";
const OPTIMIZED_ASSETS_URL = process.env.NEXT_PUBLIC_OPTIMIZED_ASSETS_HOSTNAME
  ? `https://${process.env.NEXT_PUBLIC_OPTIMIZED_ASSETS_HOSTNAME}`
  : null;

const dnsPrefetchUrls = [
  "https://www.googletagmanager.com",
  "https://www.google-analytics.com",
  "https://static.cdn.prismic.io",
  CDN_URL,
  ...(OPTIMIZED_ASSETS_URL ? [OPTIMIZED_ASSETS_URL] : []),
];

export function ResourceHints() {
  dnsPrefetchUrls.forEach((url) => {
    ReactDOM.preconnect(url, { crossOrigin: "anonymous" });
    ReactDOM.prefetchDNS(url);
  });

  return null;
}
